import { AdminToolsPanel } from '../components/admin-tools-panel';

export default class AdminToolsFlyoutController {
  /* @ngInject */
  constructor($scope) {
    $scope.AdminToolsPanel = AdminToolsPanel;
  }
}
